var _style, _g, _g2, _g3, _g4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlierGroBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510.7 183.7",
    style: {
      enableBackground: "new 0 0 510.7 183.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#262324;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GRO_x5F_white_x5F_alier",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.6,78l-1.8-2.5C93,61.9,78.5,54.4,61.9,54.4h-0.2c-14,0-27.1,6.5-36.9,18.4 c-9.9,11.9-15.3,27.9-15.3,45.1c0,35.6,22.9,63.5,52.2,63.5h0.2c16.6,0,31.2-7.3,40.9-20.6l1.8-2.4V180h23.6V55.9h-23.6L104.6,78 L104.6,78z M104.4,122.1c-0.9,10-4.7,19.2-10.8,25.7c-6.4,6.8-14.6,10.4-23.9,10.4h-0.2c-21.6,0-36.6-16.6-36.6-40.3 S48,77.6,69.5,77.6h0.2c9.2,0,17.7,3.7,24,10.5c6.2,6.6,10,15.9,10.7,26v0.1L104.4,122.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 6.3,
    className: "st2",
    width: 23.6,
    height: 173.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.9,54.4c-16.4,0-31.6,6.6-42.7,18.5c-11,11.8-17.1,27.8-17.1,45c0,36.8,25.6,63.5,60.8,63.5 c20.6,0,33.7-9,41-16.6c8.5-8.8,12.2-18.4,13.2-23.1h-24.2c-2.4,6.4-12.2,18.3-30,18.3c-20.4,0-34.1-12.7-36.9-34.1l-0.1-1.1h93.2 c0.2-2.4,0.4-5.3,0.4-8.3C401.5,81.6,376.2,54.4,343.9,54.4z M308.5,107.1l0.3-1.2c4-18.8,17.2-30.1,35.1-30.1c9,0,17,3,23,8.7 c5.6,5.3,9.5,12.7,11.1,21.4l0.2,1.2H308.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M486.4,54.5c-12.7,0-23.8,6.2-31.9,17.9l-1.8,2.6V56h-23.6v123.9h23.6v-66.6c0-11.8,3.2-20.9,9.5-27.2 c5.7-5.7,13.8-8.7,23.5-8.7c3.8,0,9.8,0.5,12.7,0.9V55.1C495.8,54.9,491.6,54.5,486.4,54.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.8,
    y: 55.9,
    className: "st2",
    width: 23.6,
    height: 123.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 242.7,
    cy: 18.7,
    rx: 17.3,
    ry: 17.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ANTI_x5F_white_x5F_alier",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.9,54.7h-0.2c-14.5,0-28,6.4-38,18.1C15.6,84.6,10,100.7,10,118.1c0,35,23.7,63.4,52.9,63.4h0.2 c16.7,0,30.9-9.8,39.1-27l0.9-2l0.9,2c1.3,3.1,8.6,21.6,10,25.4h13.7V56h-23.3l8.4,25l-0.8,0.4c-0.2,0.1-5.4,2.7-7.4,3.5l-0.9,0.3 l-0.4-0.9C95.7,65.5,81.3,54.7,63.9,54.7z M90.1,155.3c-4.8,5.3-10.7,8.1-17.6,8.4h-0.3c-0.5,0-1,0-1.6,0c-6.3,0-12-2.2-16.9-6.6 c-9-8-14.9-23.5-15.8-41.5c-0.9-16.5,3-30.8,10.5-39.1c4.7-5.2,10.6-8,17.5-8.3h0.3c6.9-0.4,13.4,2,19,7 c9.2,8.3,15.3,23.2,16,39.1C102.1,131.3,98,146.6,90.1,155.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190.9,6.4h-46.6v8.2c4.5,2.6,8.9,5.1,13.2,7.6c3,1.7,6.2,3.5,9.3,5.3l0.5,0.3v130.9l-0.8,0.5 c-7.2,4.2-14.6,8.5-22.1,12.7v8.1H191L190.9,6.4L190.9,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244,1.1c-9.7,0-17.3,7.6-17.3,17.3c0,9.8,7.6,17.5,17.3,17.5c4.7,0,9.2-1.8,12.5-5.1 c3.4-3.3,5.2-7.7,5.2-12.5C261.8,8.9,253.8,1.1,244,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.1,171.9c-3.6-2.1-7.4-4.2-11-6.2c-3.8-2.1-7.7-4.3-11.5-6.5l-0.5-0.3v-103h-46.6v8.4l22.9,12.4V159 l-0.5,0.3c-7.7,4.2-15.3,8.5-22.4,12.6v8H278v-8L278.1,171.9L278.1,171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M398.5,111.8v-1.9c0-15.5-5.4-29.5-15.2-39.4c-10-10.1-24.1-15.7-39.9-15.7c-16.4,0-31.5,6.6-42.6,18.5 c-11,11.8-17.1,27.8-17.1,44.9c0,17,6.3,32.9,17.7,44.9c11.4,12,26.6,18.5,42.8,18.5c12.8,0,24.9-4.3,35-12.4 c7.8-6.3,14.3-14.8,17.9-23.5l-8.6-4.7c-3,5.2-12.2,18.1-30.8,19.6c-12.6,0.8-23.6-2.8-32-10.4c-7.4-6.8-12.3-16.5-13.8-27.3 c-0.5-3.5-0.7-6.8-0.7-10.1v-1L398.5,111.8L398.5,111.8z M312.2,98.2c3.1-18.3,12.5-29,26.3-30.1c8.6-0.8,16.4,2.5,22.6,9.4 c4.9,5.4,8.6,13,10.1,20.7l0.2,1.2H312L312.2,98.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M484.5,83.8c4.2,4.3,8.5,8.7,16.8,8.7h1.4V56.2c-3.2-0.1-5.6-0.4-7.9-0.7c-2.6-0.4-5.1-0.7-8.6-0.7 c-16.4,0-28.1,9.4-34.7,27.9l-0.4,1.1l-9.3-4.8l6.5-22.8h-41.9v8.3c9,4.8,15.9,8.7,22.2,12.4l0.5,0.3V159l-2.5,1.4 c-6.6,3.8-13.5,7.6-20.2,11.5v8.1h71.4l-0.2-8c-8.1-4-16.3-8.4-24.2-12.6l-0.7-0.4v-51.4c0.4-9.4,2-17,4.8-22.3 c3.1-6,7.6-9.1,13.3-9.1C477,76.1,480.6,79.8,484.5,83.8z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ANTI_x5F_black",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.9,80.7c0,0-5.3,2.7-7.2,3.4C99.2,66,85,54.2,66.6,54.2h-0.2c-30.2,0-54.1,27.5-54.1,63.7 c0,35.7,24.4,63.7,53.3,63.7h0.2c17.6,0,31.6-10.6,39.6-27.3c1.4,3.4,10.1,25.7,10.1,25.7h15.2V55.4h-25.4L113.9,80.7z M75,162 h-0.2c-21.2,1.2-31.6-23.2-32.8-46.6c-1.2-23.2,7-44.9,26.8-45.9H69c19.8-1.2,32.6,22,33.5,44.6C103.7,137.4,95.3,161,75,162z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.1,16c7.7,4.6,15.2,8.7,22.7,13v128.4c-7.5,4.3-15,8.7-22.7,13v9.5h48V6.3h-48V16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.7,37.5c10.1,0,18.6-8,18.6-18.3c0-10.1-8.4-18.1-18.6-18.1c-10.1,0-18.1,8-18.1,18.1 C226.6,29.6,234.5,37.5,244.7,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.8,55.4h-48v9.9l22.7,12.3v80.1c-7.5,4.1-15.2,8.4-22.7,12.8v9.5h70.7v-9.5c-7.5-4.3-15.2-8.4-22.7-12.8 V55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M343,54.1c-34.3,0-60.1,28.5-60.1,63.7s27,63.7,60.8,63.7c28.7,0,47.3-21,53.6-36.9l-10.1-5.6 c-3.9,7.2-13.3,18.3-30.2,19.8c-26.1,1.7-41.5-16.4-44.2-36.4c-0.5-3.4-0.7-6.5-0.7-9.9h86.4v-2.9C398.5,77.8,376.1,54.1,343,54.1 z M313.1,98.3c2.7-15.4,10.4-27.8,25.1-29c18.3-1.7,28.7,15.9,31.4,29H313.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M484.2,54.1c-18.3,0-29.2,11.3-35.2,28.2l-7.5-3.9l6.5-23.1h-43.7v9.8c7.7,4.1,15.2,8.2,22.5,12.5v79.9 c-7.3,4.1-15,8.4-22.5,12.8v9.5H477l-0.2-9.5c-8.2-4.1-16.4-8.4-24.6-12.8v-50.2c0.7-17.6,6-30.2,16.9-30.2 c12.3,0,14,16.2,30.2,16.2h2.4V55.6C494.4,55.6,491.5,54.1,484.2,54.1z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "GRO_x5F_black_00000080911000654967908750000006757621930943157944_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.3,75.2C95.9,62.1,81.7,53.9,64,53.9h-0.2c-29.2,0-52.7,28.3-52.7,63.8c0,36,23.4,63.8,52.7,63.8H64 c17.6,0,31.9-8,41.3-20.8c0,4.6,0,10.6,0,19.3h25.4V55.4h-25.4C105.3,55.4,105.3,75.2,105.3,75.2z M105.1,121.8 c-1.7,19.8-15,34.8-33.3,34.8h-0.2c-21.3,0-35.3-16.4-35.3-38.9c0-22.2,13.8-38.9,35.3-38.9h0.2c18.4,0,31.9,15.2,33.3,35.3 C105.1,114.1,105.1,121.8,105.1,121.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.8,
    y: 6.4,
    className: "st3",
    width: 25.4,
    height: 173.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M343.1,53.9c-34.3,0-60.1,28.3-60.1,63.8c0,36.2,25.1,63.8,61.1,63.8c38.4,0,53.4-30.9,54.8-41.3H373 c-1.9,6.3-11.6,18.1-29,18.1c-21.3,0-33.1-14-35.5-32.8h92c0.2-2.7,0.5-5.8,0.5-9.2C401.1,82.2,376.4,53.9,343.1,53.9z  M309.3,106.1c3.6-16.9,15.5-29,33.8-29s29.7,12.6,32.8,29H309.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M484,54c-13.8,0-24.6,7-32.4,18.1V55.4h-25.4V180h25.4v-66.8c0-23.9,13.8-34.5,31.6-34.5 c4.3,0,11.6,0.7,13.5,1v-25C494.4,54.5,489.8,54,484,54z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.2,
    y: 55.4,
    className: "st3",
    width: 25.4,
    height: 124.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 242.9,
    cy: 19.6,
    rx: 18.1,
    ry: 18.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st4",
    width: 510.7,
    height: 183.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlierGroBlack);
export default __webpack_public_path__ + "static/media/alier-gro-black.76f991b71397fc8f0811841baccc995a.svg";
export { ForwardRef as ReactComponent };